import gql from 'graphql-tag';

const GET_PARENT_ORG = gql`
  query org($loggedInOrg: ID) {
    org(where: { id: $loggedInOrg}) {
      id
      name
      level
      rpm
      parentOrg {
        id
        name
        level
      }
    }
  }
`;

export default GET_PARENT_ORG;
